import AbstractVertical from './AbstractVertical'

export default class SpotHeroIQ extends AbstractVertical {

  readonly name: string = 'spothero_iq'
  readonly title: string = 'SpotHero IQ'
  readonly color: string = '#717171'

}
